import TextField from "./WorksheetTextField";
import { Alert, Box, Button, Typography } from "@mui/material";
import { CostRow, Worksheet, rowQuantity } from "./calculator";
import WorksheetMaterialCalculation from "./WorksheetMaterialCalculation";

export function materialQuantityPreview(item: Worksheet, row: CostRow) {
  try {
    return { result: rowQuantity(item, row), error: "" };
  } catch (error) {
    return { result: null, error: (error as Error).message };
  }
}

export default function WorksheetMaterialQuantity({
  item,
  row,
  onChange,
  readOnly,
  busy,
  settings,
}: {
  item: Worksheet;
  row: CostRow;
  onChange: (patch: Partial<CostRow>) => void;
  readOnly: boolean;
  busy: boolean;
  settings: any;
}) {
  const preview = materialQuantityPreview(item, row);
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h6">Coverage / Quantity</Typography>
      <WorksheetMaterialCalculation
        item={item}
        row={row}
        onChange={onChange}
        readOnly={readOnly}
        busy={busy}
        settings={settings}
      />
      {row.calculation === "manual" && (
        <TextField
          size="small"
          label="Material quantity"
          value={row.quantity}
          inputProps={{ inputMode: "decimal" }}
          disabled={readOnly || busy}
          onChange={(e) => onChange({ quantity: e.target.value })}
        />
      )}
      {row.quantityOverride != null && row.calculation !== "manual" && (
        <Alert
          severity="info"
          action={
            !readOnly && (
              <Button disabled={busy} onClick={() => onChange({ quantityOverride: null })}>
                Restore calculation
              </Button>
            )
          }
        >
          Manual quantity override: {row.quantityOverride} {row.unit}
        </Alert>
      )}
      {preview.error && <Alert severity="error">{preview.error}</Alert>}
      {preview.result && (
        <Box>
          <Typography variant="body2" sx={{ color: "#475569", fontWeight: 400 }}>
            {preview.result.formula}
          </Typography>
          <Typography fontWeight={600}>
            Quantity: {preview.result.quantity.toDecimalPlaces(6).toString()} {row.unit}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
